import pro3 from "../assets/project3.png"
import pro2 from "../assets/project2.png"
import pro1 from "../assets/project1.png"

const ProjectCardData = [
    {
        imgsrc: pro1,
        title: "Online Tutoring Website.",
        text: "This was my first project in web development where i have made a front end website using html and css only. it also includes a basic login form and it is responsive as well.This is basically the first page of a online tutoring website.It consists of a navbar and a search box. I have understood various basic concepts of html and css through this project.",
        view: " https://rishavranjan786.github.io/calculator/"
    },
    {
        imgsrc: pro2,
        title: "Fully Functional Calculator",
        text: "This is a fully functional and responsive calculator made using html,css and javascript. I have given the github link of this project.Do have a look and check it out by performing some calculations.There are two buttons provided below. 'Clear' button is used to clear the previous inputs and 'Calculate' button is used for giving the output of an arithmetic operation.",
        view: "https://rishavranjan786.github.io/calculator/"
    },

    {
        imgsrc: pro3,
        title: "Flight Booking Website",
        text: "This website is made through html,css and javascript which shows the front-end of an online flight booking system.It consists of multiple pages and you can navigate from one page to another page through various butttons  provided in the page.It also shows the various services offered in our flight.I will make it a fully functional website by includng the backend also.",
        view: "https://rishavranjan786.github.io/Flight-Tour-and-Travels/"
    },
];


export default ProjectCardData;